import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    LayoutDashboard, Users, UserPlus, Package, MapPin,
    Briefcase, Car, Calendar, Settings, ArrowUpRight, X, Activity, Shield
} from 'lucide-react';
import './Sidebar.css';

const Sidebar = ({ isOpen, setIsOpen, isDesktop }) => {
    const navItems = [
        { path: '/', label: 'Dashboard', icon: LayoutDashboard },
        { path: '/leads', label: 'Lead Management', icon: UserPlus },
        { path: '/customers', label: 'Customers', icon: Users },
        { path: '/packages', label: 'Packages & Deals', icon: Package },
        { path: '/branches', label: 'Branch Manager', icon: MapPin },
        { path: '/staff', label: 'Support Staff', icon: Briefcase },
        { path: '/instructors', label: 'Instructors', icon: Users },
        { path: '/vehicles', label: 'Vehicle Fleet', icon: Car },
        { path: '/scheduling', label: 'Scheduling & Diary', icon: Calendar },
        { path: '/kpis', label: 'KPI Configuration', icon: Activity },
        { path: '/users', label: 'User Management', icon: Shield },
        { path: '/settings', label: 'Settings', icon: Settings },
    ];

    return (
        <div className={`sidebar ${(isOpen && !isDesktop) ? 'open' : ''} ${!isDesktop ? 'mobile' : ''}`}>
            <div className="sidebar-header">
                <div className="flex items-center gap-3">
                    <div className="logo-icon">S</div>
                    <div className="logo-text">
                        <span className="logo-title">Safety Driver</span>
                        <span className="logo-subtitle">TRAINING</span>
                    </div>
                </div>
                {!isDesktop && (
                    <button className="close-sidebar" onClick={() => setIsOpen(false)}>
                        <X size={24} />
                    </button>
                )}
            </div>

            <nav className="sidebar-nav">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        onClick={() => !isDesktop && setIsOpen(false)}
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    >
                        <item.icon size={20} className="nav-icon" />
                        <span className="nav-label">{item.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="sidebar-footer" style={{ padding: '24px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                <button
                    onClick={() => {
                        const config = window.reactPress || window.rpVars || {};
                        const siteUrl = config.api?.rest_url?.split('/wp-json')[0] || '/';
                        window.location.href = siteUrl;
                    }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px 16px',
                        width: '100%',
                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                        color: '#ef4444',
                        borderRadius: '12px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        transition: 'all 0.2s ease',
                        border: '1px solid rgba(239, 68, 68, 0.2)',
                        cursor: 'pointer'
                    }}
                >
                    <ArrowUpRight size={18} style={{ transform: 'rotate(45deg)' }} />
                    Logout
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
